import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_AUDIENCE_META_PARAM } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The capability reel finishes its first play and the outcomes screen appears',
  name: 'agent_onboarding_demo_completed',
  params: [WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM, AGENT_ONBOARDING_AUDIENCE_META_PARAM],
};

export default META;
